module.exports = __webpack_public_path__ + "static/media/vest.3efbdcf2.jpg";